module.exports = __webpack_public_path__ + "img/beian.png";